import React from "react";
import styles from "./style.module.scss";
import MeetUsWrapper from "Components/MeetUsWrapper";
import aboutbg from "Utils/Assets/Images/aboutbg.png";
import IconCoreValues from "../../../Utils/Assets/Images/IconCoreValues.png";
import IconCoreValues1 from "../../../Utils/Assets/Images/IconCoreValues1.png";
import IconCoreValues2 from "../../../Utils/Assets/Images/IconCoreValues2.png";
import IconCoreValues3 from "../../../Utils/Assets/Images/IconCoreValues3.png";
import community from "../../../Utils/Assets/Images/community.png";
import innovation from "../../../Utils/Assets/Images/innovation.png";
import empowerment from "../../../Utils/Assets/Images/empowerment.png";
import trust from "../../../Utils/Assets/Images/trust.png";
import inspiration from "../../../Utils/Assets/Images/inspiration.png";

const CoreValuesSection = () => {
    const [activeCard, setActiveCard] = React.useState(0);
    const intervalRef = React.useRef(null);

    const startAutoSwitch = React.useCallback(() => {
        clearInterval(intervalRef.current);
        intervalRef.current = setInterval(() => {
            setActiveCard((prev) => (prev + 1) % 5);
        }, 2500);
    }, []);

    const stopAutoSwitch = React.useCallback(() => {
        clearInterval(intervalRef.current);
    }, []);

    React.useEffect(() => {
        startAutoSwitch();
        return () => clearInterval(intervalRef.current);
    }, [startAutoSwitch]);

    const cardsData = [
        {
            id: 0,
            icon: IconCoreValues,
            mainImage: community,
            title: "Community",
            description: "Genuine relationships that go beyond borders.",
        },
        {
            id: 1,
            icon: IconCoreValues2,
            mainImage: innovation,
            title: "Innovation",
            description: "Pioneering VR and blockchain solutions.",
        },
        {
            id: 2,
            icon: IconCoreValues3,
            mainImage: empowerment,
            title: "Empowerment",
            description:
                "Financial independence through tokenized rewards.",
        },
        {
            id: 3,
            icon: IconCoreValues,
            mainImage: trust,
            title: "Trust",
            description:
                "Secure and transparent ecosystem.",
        },
        {
            id: 4,
            icon: IconCoreValues1,
            mainImage: inspiration,
            title: "Inspiration",
            description:
                "Creativity and collaboration in the metaverse.",
        },
    ];

    return (
        <div className={styles.coreValues}>
            <img
                src={aboutbg}
                alt="coreValuesBg"
                className={styles.coreValuesBg}
            />
            <MeetUsWrapper>
                <div className={styles.coreValuesContent}>
                    <div className="">
                        <h1 className={styles.coreValuesTitle}>
                            Our Core Values
                        </h1>
                    </div>

                    <div className={styles.flex}>
                        <div
                            className={styles.cards}
                            onMouseLeave={startAutoSwitch}
                        >
                            {cardsData.map((card, index) => (
                                <div
                                    key={card.id}
                                    className={
                                        activeCard === index
                                            ? styles.card
                                            : styles.card1
                                    }
                                    onMouseEnter={() => {
                                        stopAutoSwitch();
                                        setActiveCard(index);
                                    }}
                                >
                                    <div className={styles.icon}>
                                        <img src={card.icon} alt={card.title} />
                                    </div>
                                    <h2>{card.title}</h2>
                                    <p className="">{card.description}</p>
                                </div>
                            ))}
                        </div>
                        <div
                            className={styles.image}
                            data-aos="fade-left"
                            data-aos-duration="800"
                            data-aos-once="false"
                        >
                            <img
                                key={activeCard}
                                src={cardsData[activeCard].mainImage}
                                alt="ImageCoreValues"
                            />
                        </div>
                    </div>
                </div>
            </MeetUsWrapper>
        </div>
    );
};

export default CoreValuesSection;
